module.exports = __webpack_public_path__ + "static/media/Pricelist.a88b0ab3.pdf";